module.exports = __webpack_public_path__ + "static/media/Macbook4.a5279d81.png";